import axios from "axios";
import { logout } from "../lib/auth";
import { accountRunkingTableColumn } from "../config/accountRunking";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// ランキング一覧
export async function getAccountRunkings(
  props: { [key: string]: number | string },
  sortColumn: {
    key: string;
    sort: string;
  }[],
) {
  try {
    const path = "accountRunkings";
    const params = makeParams(accountRunkingTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl2 + path, {
      params: { ...params, sortColumn },
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const accountRunkings: dataDifine[] = response.data.fetch_data;
    const countAccountRunkings: string = response.data.count_data;
    return { accountRunkings, countAccountRunkings };
  } catch (error) {
    // logout();
  }
}
